import { RECEIVED_AVAILABLE_PRODUCTS } from '../actions';
import Immutable from 'immutable';

const defaultState = Immutable.fromJS({
  list: {},
});

export function products(state = defaultState, action = null) {
  switch (action.type) {
    case RECEIVED_AVAILABLE_PRODUCTS: {
      const newMap = Immutable.Range(0, action.products.length).map(i => [
        action.products[i].id,
        action.products[i],
      ]);
      return state.update('list', list =>
        list.update(map => map.merge(Immutable.Map(newMap)))
      );
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/products.js